export const HoverScaleAnimation = {
  transition: "all 250ms ease-in-out",
  ":hover": {
    transform: "scale(1.2)",
  },
};
